export default {
  file: {
    id: 'bo_sellers-orders-drawers-import_csv_file-select_file',
    defaultMessage: 'Select your file',
  },
  fileFormat: {
    id: 'bo_sellers-orders-drawers-import_csv_file-format_description',
    defaultMessage: 'in CSV format',
  },
  delimiter: {
    id: 'bo_sellers-orders-drawers-import_csv_file-fields_delimiter_label',
    defaultMessage: 'Separator',
  },
  encoding: {
    id: 'bo_sellers-orders-drawers-import_csv_file-fields_encoding_label',
    defaultMessage: 'Encoding',
  },
  optionDelimiterSemicolon: {
    id: 'bo_sellers-orders-drawers-import_csv_file-delimiter_semicolon',
    defaultMessage: '; (semicolon)',
  },
  optionDelimiterTab: {
    id: 'bo_sellers-orders-drawers-import_csv_file-delimiter_tab',
    defaultMessage: '\t (tab)',
  },
  optionDelimiterComma: {
    id: 'bo_sellers-orders-drawers-import_csv_file-delimiter_comma',
    defaultMessage: ', (comma)',
  },
} as const
